<template>
    <div class="tabs layout-column noscroll" v-if="allow">
        <div class="wrapper_header_sidebar">
            <div class="header_sidebar_wrpr">
	            <a @click="linkTo(null)" class="small-btn back_btn">

		            <svg fill="none" viewBox="0 0 14 12" height="12" width="14">
			            <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M3.38389 3.74999H10C12.0711 3.74999 13.75 5.42892 13.75 7.49999C13.75 9.57105 12.0711 11.25 10 11.25H8.4375V9.99999H10C11.3807 9.99999 12.5 8.8807 12.5 7.49999C12.5 6.11927 11.3807 4.99999 10 4.99999H3.38389L6.06694 7.68304L5.18306 8.56693L0.991119 4.37499L5.18306 0.183044L6.06694 1.06693L3.38389 3.74999Z" fill="#C5C7D2"></path>
		            </svg>
<!--		            <inline-svg :src="require('@/assets/icons/back.svg')" />-->
	            </a>
              <h4 class="title_sidebar">{{editType}}</h4>
	            <v-button v-if="isSuper" class="small-btn" v-tippy="{theme:'small-black'}" @click="saveCompOpen=true"
	                      content="Save as composition" flat :icon="require('@/assets/img/store.svg')" />

	            <v-button class="small-btn" v-tippy="{theme:'small-black'}" @click="saveAssetOpen=true"
	                      content="Save as asset" flat :icon="require('@/assets/img/content-save-check-outline.svg')" />

	            <portal to="popup" v-if="saveCompOpen">
		            <save-comp-popup :element="content" @close="saveCompOpen=false" @newGroup="newCompGroupOpen=true" @done="saveCompOpen=false" />
	            </portal>
	            <portal to="popup" v-if="newCompGroupOpen">
		            <new-comp-group-popup @close="newCompGroupOpen=false" @done="newCompGroupOpen=false" />
	            </portal>

	            <portal to="popup" v-if="saveAssetOpen">
		            <save-asset-popup :element="content" @close="saveAssetOpen=false" @newGroup="newGroupOpen=true" @done="saveAssetOpen=false" />
	            </portal>
	            <portal to="popup" v-if="newGroupOpen">
		            <new-asset-group-popup @close="newGroupOpen=false" @done="newGroupOpen=false" />
	            </portal>

            </div>
            <ul id="tabs-nav">
                <li>
                    <a @click="linkTo('basic')" :class="{'active': page_tab === 'basic'}">Basic</a>
                </li>
	            <li v-if="hasHover">
		            <a @click="linkTo('hover')" :class="{'active': page_tab === 'hover'}">Hover</a>
	            </li>
	            <li v-if="hasActive">
		            <a @click="linkTo('active')" :class="{'active': page_tab === 'active'}">Active</a>
	            </li>
                <li>
                    <a @click="linkTo('advanced')" :class="{'active': page_tab === 'advanced'}">Advanced</a>
                </li>
            </ul>
        </div>
        <div id="tabs-content" class="layout-column noscroll">
            <component :is="page_tab" :key="page_id" :content="content"/>
        </div>
    </div>
</template>

<script>
import basic from "@/modules/page-editor/src/components/sidebar/Basic.vue"
import advanced from "@/modules/page-editor/src/components/sidebar/Advanced.vue"
import hover from "@/modules/page-editor/src/components/sidebar/Hover"
import active from "@/modules/page-editor/src/components/sidebar/Active"
import { mapGetters } from "vuex"
import pageProperties from '@/modules/page-editor/src/components/sidebar/PageProperties';
import popupProperties from '@/modules/page-editor/src/components/sidebar/PopupProperties';
import layout from '@/modules/page-editor/src/components/sidebar/Layout';
import Settings from '@/modules/page-editor/src/components/sidebar/Settings';
import Popups from '@/modules/page-editor/src/components/sidebar/Popups';
import VButton from "@/components/base/v-button";
import SaveAssetPopup from "@/modules/page-editor/src/components/sidebar/popups/save-asset-popup";
import NewAssetGroupPopup from "@/modules/page-editor/src/components/sidebar/popups/new-asset-group-popup";
import SaveCompPopup from "@/modules/page-editor/src/components/sidebar/popups/save-comp-popup";
import NewCompGroupPopup from "@/modules/page-editor/src/components/sidebar/popups/new-comp-group-popup";

export default {
    name: 'PropertiesPanel',
    components: {
	    NewCompGroupPopup,
	    SaveCompPopup,
	    NewAssetGroupPopup,
	    SaveAssetPopup,
	    VButton,
			active,
	    popupProperties,
	    	layout,
	      pageProperties,
        basic,
        advanced,
        hover,
	    Settings,
	    Popups
    },
    data: function(){
        return {
	        newGroupOpen:false,
	        newCompGroupOpen:false,
	        saveAssetOpen:false,
	        saveCompOpen:false,
          allow: false
        }
    },
    computed: {
      ...mapGetters(['page_findOne', 'page_tab', 'page_id', 'current_popup']),
      editType(){
        if(this.content)
          return this.content.type;
        else return false
      },
      content() {
          return this.page_findOne(this.page_id, !!this.current_popup);
      },
	    hasHover() {
      	if (!this.content) return false;
		    return ['button','link','faq'].includes(this.content.type);
	    },
	    hasActive() {
		    if (!this.content) return false;
		    return ['faq'].includes(this.content.type);
	    },
	    isSuper() {
				return this.$store.state.userInfo.id===3
	    }
    },
    methods: {
        linkTo(tab) {
            this.$store.commit('PAGE_SET_TAB', tab)
        }
    },
    mounted() {
        if(this.page_findOne(this.page_id, !!this.current_popup) === undefined) this.linkTo(null);
        else this.allow = true
    }
}
</script>


<style lang="scss">
.main .wrapper_main .sidebar .title_sidebar {
    text-transform: capitalize;
}
</style>
